// Feb 29 common-year substitute — shared by the picker, the profile page and
// their tests (profile spec §2.1 P3).
//
// Lives in `lib/` rather than in the component file because
// `eslint --max-warnings=0` runs `react-refresh/only-export-components`: a
// component file that also exports constants trips it, and this repo's lint
// gate treats that warning as a failure.

/** The two substitutes the product offers for a Feb 29 birthday. */
export interface NonLeapChoice {
  month: 2 | 3;
  day: 28 | 1;
}

export const NON_LEAP_CHOICES: readonly NonLeapChoice[] = [
  { month: 2, day: 28 },
  { month: 3, day: 1 },
];

export function isNonLeapChoice(
  month: number | null | undefined,
  day: number | null | undefined,
): month is 2 | 3 {
  return NON_LEAP_CHOICES.some((c) => c.month === month && c.day === day);
}

export function nonLeapChoiceFrom(
  month: number | null | undefined,
  day: number | null | undefined,
): NonLeapChoice | null {
  if (!isNonLeapChoice(month, day)) return null;
  return { month, day: day as 28 | 1 };
}

export function nonLeapLabel(choice: NonLeapChoice): string {
  return choice.month === 2 ? "2 月 28 日" : "3 月 1 日";
}

/** True when this birthday needs a substitute at all. */
export function needsNonLeapChoice(birthday: string | null | undefined): boolean {
  return typeof birthday === "string" && birthday.slice(5, 10) === "02-29";
}
